import * as i0 from '@angular/core';
import { EventEmitter, Directive, Output, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class InViewportDirective {
    constructor(element) {
        this.element = element;
        this.fstrInViewport = new EventEmitter();
        this.delay = 500;
        this.once = true;
        this.threshold = 0;
        this._isIntersecting = false;
    }
    ngAfterViewInit() {
        if (typeof window !== 'undefined' &&
            window['IntersectionObserver'] !== undefined) {
            setTimeout(() => {
                const callback = (e) => {
                    if (e[0].isIntersecting) {
                        this._isIntersecting = true;
                        this.fstrInViewport.emit(this._isIntersecting);
                        if (this.once) {
                            observer.disconnect();
                        }
                    }
                    else if (this._isIntersecting && !e[0].isIntersecting) {
                        this._isIntersecting = false;
                        this.fstrInViewport.emit(this._isIntersecting);
                    }
                };
                const observer = new IntersectionObserver(callback, {
                    threshold: [this.threshold],
                });
                observer.observe(this.element.nativeElement);
            }, this.delay);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: InViewportDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.2", type: InViewportDirective, selector: "[fstrInViewport]", inputs: { delay: "delay", once: "once", threshold: "threshold" }, outputs: { fstrInViewport: "fstrInViewport" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: InViewportDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fstrInViewport]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { fstrInViewport: [{
                type: Output
            }], delay: [{
                type: Input
            }], once: [{
                type: Input
            }], threshold: [{
                type: Input
            }] } });

class InViewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: InViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.2", ngImport: i0, type: InViewModule, declarations: [InViewportDirective], imports: [CommonModule], exports: [InViewportDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: InViewModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.2", ngImport: i0, type: InViewModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [InViewportDirective],
                    exports: [InViewportDirective],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { InViewModule, InViewportDirective };
